export const isFacebookTimeoutError = (error?: string): boolean =>
    !!error?.match(
        /(ETIMEDOUT)|(ESOCKETTIMEDOUT)|(Service temporarily unavailable)|(Please retry your request later)|(Video Creation failed, please try again)/
    );
